import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";

function PromotionalBar() {
  const { promoBanners } = useSelector((state) => state.promoCodes);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false); // track hover
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!promoBanners || promoBanners.length <= 1) return;

    // Clear previous interval
    if (intervalRef.current) clearInterval(intervalRef.current);

    // Only set interval if NOT hovered
    if (!isHovered) {
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % promoBanners.length);
      }, 5000); // 5 seconds
    }

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [promoBanners, isHovered]);

  if (!promoBanners || promoBanners.length === 0) return null;

  return (
    <div
      className="relative w-full bg-black h-12"
      onMouseEnter={() => setIsHovered(true)}   // pause on hover
      onMouseLeave={() => setIsHovered(false)} // resume when mouse leaves
    >
      {promoBanners.map((banner, i) => (
        <div
          key={i}
          className={`absolute inset-0 flex items-center justify-center transition-opacity duration-1000 ${
            i === currentIndex ? "opacity-100" : "opacity-0"
          }`}
        >
          <div className="text-center text-white text-lg px-4 py-2 flex items-center justify-center gap-2">
            {banner}
          </div>
        </div>
      ))}
    </div>
  );
}

export default PromotionalBar;